/**
 * Returns an initial from either a full name or a first name and last name.
 */
export function initialsFromName(firstName?: string, lastName?: string): string;
export function initialsFromName(fullName?: string): string;
export function initialsFromName(
  firstNameOrFullName: string = "",
  lastName: string = ""
): string {
  let firstInitial = "";
  let lastInitial = "";
  if (lastName) {
    firstInitial = firstNameOrFullName.length > 0 ? firstNameOrFullName[0] : "";
    lastInitial =
      lastName.length > 0
        ? lastName[0]
        : // istanbul ignore next - default
          "";
  } else {
    const parts = firstNameOrFullName.split(" ");
    firstInitial = parts[0].length > 0 ? parts[0][0] : "";
    lastInitial = (parts[1] || "").length > 0 ? parts[1][0] : "";
  }
  return `${firstInitial.toUpperCase()}${lastInitial.toUpperCase()}`;
}
